import {Component, OnInit} from '@angular/core';
import {DefaultComponent} from '../default/default.component';

@Component({
    selector: 'app-highschool',
    templateUrl: './highschool.component.html'
})
export class HighschoolComponent extends DefaultComponent implements OnInit {
    protected product = 'hs';
}
